import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useHistory } from 'react-router';
import { routesApp } from 'src/routesService';
import { validateOnePermission } from 'src/helpers/permissions';
import { AGRUPADORES_PERMISSIONS, FAQS_PERMISSIONS } from 'src/utils/constants/permissions';
import DeleteItem from 'src/components/shared/DeleteItem';

const ITEM_HEIGHT = 48;

export default function Actions(props) {
  const {
    agrupador,
    authPermissions,
    deleteAgrupador,
  } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '24ch',
          },
        }}
      >
        {
          validateOnePermission(authPermissions, FAQS_PERMISSIONS.VIEW_FAQ) &&
          <MenuItem onClick={() => {
            history.push(routesApp.faqs.path.replace(":agrupadorId", agrupador.id));
          }}>
            Administrar FAQs
          </MenuItem>
        }
        {
          validateOnePermission(authPermissions, AGRUPADORES_PERMISSIONS.EDIT_AGRUPADOR) &&
          <MenuItem onClick={() => {
            history.push(routesApp.editAgrupador.path.replace(":agrupadorId", agrupador.id));
          }}>
            Editar
          </MenuItem>
        }
        {validateOnePermission(authPermissions, AGRUPADORES_PERMISSIONS.DELETE_AGRUPADOR) &&
          <DeleteItem 
            deleteAction={deleteAgrupador}
            item={agrupador.id}
            message={`¿Deseas eliminar el agrupador "${agrupador.name}"?`}
            title="Eliminar Agrupador"
          />
        }
      </Menu>
    </div>
  );
}
